import { isValidDayjs, Yup } from '@shared/utils'

export const initialValues = {
  dateType: 'ordered_date',
  startDate: null,
  endDate: null,
  status: [],
  cbo: [],
}

export const toApiValues = (values, { isAdmin } = {}) => {
  const data = {
    date_filter: values.dateType,
    from_date: values.startDate?.format('YYYY-MM-DD'),
    to_date: values.endDate?.format('YYYY-MM-DD'),
    status: values.status,
  }

  if (isAdmin && values.cbo.length > 0) {
    data.cbo = values.cbo
  }

  return data
}

export const validationSchema = Yup.object()
  .shape({
    dateType: Yup.string().oneOf(['ordered_date', 'creation_date', 'results_received_date']).required('Required'),
    startDate: Yup.object().nullable().required('Required').test('invalid-start', 'Invalid Date', isValidDayjs),
    endDate: Yup.object().nullable().required('Required').test('invalid-end', 'Invalid Date', isValidDayjs),
    status: Yup.array().of(Yup.string()).nullable(),
  })
  .test({
    name: 'validate-range',
    test: function ({ startDate, endDate }) {
      // Let the field-level errors handle "Invalid Date"
      if (!isValidDayjs(startDate) || !isValidDayjs(endDate)) return false

      if (startDate.isAfter(endDate)) {
        return this.createError({ path: 'range', message: 'Start must be before End' })
      }

      if (endDate.diff(startDate, 'year') >= 1) {
        return this.createError({ path: 'range', message: 'Range cannot exceed 1 year' })
      }

      return true
    },
  })
